import { Card, CardContent } from "@/shared/components/ui/card";
import andersonCooper from "@/shared/assets/media/anderson_cooper.svg";
import terrible from "@/shared/assets/media/terrible.svg";

const podcasts = [
  {
    title: "All There Is with Anderson Cooper",
    episodes: "38 episodes",
    network: "CNN Podcasts",
    image: andersonCooper,
    url: "https://www.cnn.com/all-there-is-anderson-cooper",
  },
  {
    title: "Terrible, Thanks for Asking",
    episodes: "236 episodes",
    network: "Feelings & Co",
    image: terrible,
    url: "https://feelingsand.co/podcasts/terrible-thanks-for-asking/",
  },
];

export default function Podcasts() {
  return (
    <div>
      <p className="text-base font-medium mb-2">Podcasts about loss and healing</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {podcasts.map((podcast, index) => (
          <a
            key={index}
            href={podcast.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block no-underline"
          >
            <Card className="border-primary bg-white rounded-xl overflow-hidden cursor-pointer shadow-none transition-colors hover:bg-subtle">
              <CardContent className="p-0">
                <div className="flex overflow-hidden min-h-[104px]">
                  {/* Podcast cover image */}
                  <div className="self-stretch flex-shrink-0 w-[104px]">
                    <img
                      src={podcast.image}
                      alt={podcast.title}
                      className="h-full w-full object-cover"
                    />
                  </div>

                  {/* Content */}
                  <div className="flex-1 p-4 min-w-0 min-h-[104px] flex flex-col justify-center">
                    <h4 className="font-semibold text-sm text-primary truncate">{podcast.title}</h4>
                    <p className="text-sm font-light text-stone-600 mt-1">
                      {podcast.episodes} • {podcast.network}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </a>
        ))}
      </div>
    </div>
  );
}
